/*
  MENU ITEMS
  path - url path in browser to match active class to highlight item
  route ame is the vue router route name
*/
export default [

  {
    title: "Dashboard",
    routeName: "dashboard",
    icon: "lni lni-dashboard",
    paths: ["/dashboard"],
    active: false
  },

  {
    title: "Orders",
    routeName: "orders",
    icon: "lni lni-folder",
    paths: ["/orders"],
    permissions:['manage orders'],
    active: false
  }, 
  
  {
    title: "Users & Roles",
    icon: "lni lni-users",
    paths: ["/users","/roles"],
    active: false,
    permissions:['manage users','manage roles'],
    childVisible: false,
    children: [
      {
        title: "User Management",
        routeName: "users",
        permissions:['manage users'],
      },
      {
        title: "Roles Management",
        routeName: "roles",
        permissions:['manage roles'],
      }
    ]
  },

  {
    title: "Horizon",
    routeName: "horizon",
    icon: "lni lni-ubuntu",
    paths: ["/horizon"],
    permissions:['manage system'],
    active: false
  },

  {
    title: "Telescope",
    routeName: "telescope",
    icon: "lni lni-ubuntu",
    paths: ["/telescope"],
    permissions:['manage system'],
    active: false
  },
]